import { BaseCallback } from './BaseCallback';
import { WechatJsBridge } from './WechatJsBridge';
import { AppJsBridge } from './AppJsBridge';

class VrApp extends BaseCallback {
  #jsBridgeInstance;

  #buildMethod() {
    const methodNameSet = new Set();
    const ignoreList = ['constructor', 'init'];
    // 遍历WechatJsBridge类的方法
    for (const propertyName of Object.getOwnPropertyNames(WechatJsBridge.prototype)) {
      if (
        typeof WechatJsBridge.prototype[propertyName] === 'function' &&
        ignoreList.indexOf(propertyName) === -1
      ) {
        methodNameSet.add(propertyName);
      }
    }
    // 遍历AppJsBridge类的方法
    for (const propertyName of Object.getOwnPropertyNames(AppJsBridge.prototype)) {
      if (
        typeof AppJsBridge.prototype[propertyName] === 'function' &&
        ignoreList.indexOf(propertyName) === -1
      ) {
        methodNameSet.add(propertyName);
      }
    }
    // 构建方法实际逻辑
    for (const methodName of Array.from(methodNameSet)) {
      if (this.#jsBridgeInstance) {
        // 调用实际实例的正真方法
        if (this.#jsBridgeInstance[methodName]) {
          this[methodName] = (...args) => {
            return this.#jsBridgeInstance[methodName].apply(this.#jsBridgeInstance, args);
          };
        } else {
          // 实际实例没有实现该方法，返回错误
          this[methodName] = () => {
            return Promise.reject(
              this.fail({ msg: `${this.#jsBridgeInstance.platform}暂不支持${methodName}` })
            );
          };
        }
      } else {
        // 实际实例没有被初始化，返回错误
        this[methodName] = () => {
          return Promise.reject(this.fail({ msg: `SDK未初始化` }));
        };
      }
    }
  }

  constructor() {
    super();
    // 建立未初始化的空方法
    this.#buildMethod();
  }

  /**
   * 初始化SDK
   * @param {Object} config 配置
   * @param {Object} config.wechat 微信配置
   * @param {Object} config.wechat.sdkUrl=https://res.wx.qq.com/open/js/jweixin-1.6.0.js 微信sdk url
   * @param {Object} config.app app配置
   * @returns {Promise<*>}
   */
  async init(config) {

    let configData;
    if (config?.wechat) {
      this.#jsBridgeInstance = new WechatJsBridge();
      configData = config.wechat;
    } else if (config?.app) {
      this.#jsBridgeInstance = new AppJsBridge();
      configData = config.app;
    } else {
      return Promise.reject(this.fail({ msg: '配置错误' }));
    }

    // 重建调用对应实例的真实方法
    this.#buildMethod();

    return this.#jsBridgeInstance.init(configData);
  }
}

export { VrApp };
